import { createAsyncThunk } from "@reduxjs/toolkit";
import { DashboardWidgetLargestCostChanges } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { costAnomaliesWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/cost-anomalies/costAnomaliesWidgetByIdSelector";
import { updateWidgetThunk } from "@/store/dashboards/thunks/widgets/common/updateWidgetThunk";
import { UpdateDashboardWidgetRequestType } from "@/store/dashboards/utils/types/types";
import { openWidgetBuildingSnackbar } from "@/store/dashboards/thunks/widgets/utils/openWidgetBuildingSnackbar";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { getCostAnomaliesWidgetDataByWidgetIdThunk } from "@/store/dashboards/thunks/widgets/cost-anomalies/data-get/getCostAnomaliesWidgetDataByWidgetIdThunk";

export const updateCostAnomaliesWidgetFromQuickActionsThunk = createAsyncThunk(
  "dashboards/updateCostAnomaliesWidgetFromQuickActions",
  async (
    updatedWidget: Partial<DashboardWidgetLargestCostChanges>,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    if (!updatedWidget.id) {
      return;
    }

    const widget = costAnomaliesWidgetByIdSelector(state, updatedWidget.id);

    try {
      const response = await dispatch(
        updateWidgetThunk({
          widget: {
            ...widget,
            ...updatedWidget,
          } as UpdateDashboardWidgetRequestType,
          widgetId: updatedWidget.id,
        }),
      ).unwrap();

      if (response) {
        openWidgetBuildingSnackbar("largest_cost_changes", "update");
      }

      if (response) {
        await dispatch(
          getCostAnomaliesWidgetDataByWidgetIdThunk({
            widgetId: response.id,
            forceRefetch: true,
          }),
        );
      }

      return response;
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);

      return null;
    }
  },
);
